// extracted by mini-css-extract-plugin
module.exports = {"container":"B_c","image":"B_f"};